"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EQueues = void 0;
var EQueues;
(function (EQueues) {
    EQueues["EMAIL"] = "EMAIL";
    EQueues["FILE"] = "FILE";
})(EQueues || (exports.EQueues = EQueues = {}));
